// @flow

import React from 'react';
import { QuestionListItem } from './atoms';

type Props = {|
  questions: Array<{
    question: string,
    url: string,
  }>,
|};

export default ({
  questions,
}: Props) => (
  <>
    {questions.map(({ question, url }) => (
      <QuestionListItem key={url} href={url}>{question}</QuestionListItem>
    ))}
  </>
);
